/**
 * 场景配置数据源地址集中管理。
 *
 * 场景列表配置统一从 COS 静态 JSON 文件读取，不再使用无极（wuji）接口。
 *
 * @changelog
 * | 版本   | 变更说明                                                 | 关联                  |
 * | v1.0.0 | 初始实现：集中场景配置 API 常量，消除多文件 URL 重复      | REQ: 消除重复 URL     |
 * | v2.0.0 | 数据源迁移：从无极 API 切换到 COS 静态 JSON 统一数据源    | REQ: 场景列表COS化    |
 * /@changelog
 *
 * @author v_djlzhou
 */

/** 场景配置数据源 URL（COS 静态 JSON，全环境统一） */
export const SCENE_CONFIG_URL =
  'https://mogs-1300354879.cos.ap-shanghai.myqcloud.com/mogs/nobody/gs-viewer/config/scene_v2.json';
